import Conversation1 from "../../assets/Conversation1.svg";
import Conversation2 from "../../assets/Conversation2.svg";

import React from "react";
import "./ConversationSection.css";

const ConversationSection = () => {
  return (
    <section className="conversation-section">
      <div className="c-left-content">
        <img
          src={Conversation1}
          alt="Book and Wildlife"
          className="wildlife-image"
        />
      </div>
      <div className="c-right-content">
        <div className="c-right-top">
          <h2 className="title">
            "The best teachers are not always in classrooms; sometimes they sit
            across from you at dinner."
          </h2>
          <a href="/conversations " className="btn">
            Tales across the Table
          </a>
        </div>

        <div className="c-right-bottom">
          <img
            src={Conversation2}
            alt="People Conversing"
            className="inian-image"
          />
        </div>
      </div>
    </section>
  );
};

export default ConversationSection;
